import React from "react";
import LoadingLogo from "./LoadingLogo";

const toCssLength = (v) => (typeof v === "number" ? `${v}px` : v);

const TableLoadingArea = ({ loading, children, className, minHeight = 200 }) => {
  const mh = toCssLength(minHeight);
  const wrapStyle = { minHeight: mh };

  if (loading) {
    return (
      <div
        className={className}
        style={{
          ...wrapStyle,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingLogo />
      </div>
    );
  }

  return (
    <div className={className} style={wrapStyle}>
      {children}
    </div>
  );
};

export default TableLoadingArea;
